import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axios"; // ← con interceptors (token + 401/403)

const GestionReservas = () => {
  const navigate = useNavigate();

  const [reservas, setReservas] = useState([]);
  const [reservasFiltradas, setReservasFiltradas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroEstado, setFiltroEstado] = useState("TODAS");

  // Modal rechazo
  const [mostrarModalRechazo, setMostrarModalRechazo] = useState(false);
  const [reservaIdParaRechazar, setReservaIdParaRechazar] = useState(null);
  const [motivoRechazo, setMotivoRechazo] = useState("");

  // Modal aprobación
  const [mostrarModalAprobar, setMostrarModalAprobar] = useState(false);
  const [reservaIdParaAprobar, setReservaIdParaAprobar] = useState(null);

  const [alerta, setAlerta] = useState({
  mostrar: false,
  mensaje: "",
  tipo: "success"
});

  // Cargar todas las reservas
  const cargarReservas = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/reservas");
      setReservas(response.data.reservas || []);
    } catch (error) {
      console.error("Error al cargar reservas:", error);
      // interceptor ya maneja 401/403 → aquí solo otros errores
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarReservas();
  }, []);

  // Aplicar filtro
  useEffect(() => {
    if (filtroEstado === "TODAS") {
      setReservasFiltradas(reservas);
    } else {
      setReservasFiltradas(
        reservas.filter((reserva) => reserva.estado === filtroEstado)
      );
    }
  }, [reservas, filtroEstado]);

  // ── Aprobar reserva ────────────────────────────────────────────────
  const abrirModalAprobar = (id) => {
    setReservaIdParaAprobar(id);
    setMostrarModalAprobar(true);
  };

  const confirmarAprobar = async () => {
    try {
      await axios.put(`/reservas/${reservaIdParaAprobar}/estado`, {
        estado: "APROBADA",
        observacion: null,
      });

      setMostrarModalAprobar(false);
      setReservaIdParaAprobar(null);
      cargarReservas();
    } catch (error) {
      console.error("Error al aprobar:", error);
      mostrarAlerta(error.response?.data?.message || "No se pudo aprobar la reserva", "danger");
    }
  };

  // ── Rechazar reserva ───────────────────────────────────────────────
  const abrirModalRechazo = (id) => {
    setReservaIdParaRechazar(id);
    setMotivoRechazo("");
    setMostrarModalRechazo(true);
  };

  const confirmarRechazo = async () => {
    if (!motivoRechazo.trim()) {
      mostrarAlerta("Debe ingresar un motivo para rechazar la reserva.", "danger");
      return;
    }

    try {
      await axios.put(`/reservas/${reservaIdParaRechazar}/estado`, {
        estado: "RECHAZADA",
        observacion: motivoRechazo.trim(),
      });

      setMostrarModalRechazo(false);
      setReservaIdParaRechazar(null);
      setMotivoRechazo("");
      cargarReservas();
    } catch (error) {
      console.error("Error al rechazar:", error);
      mostrarAlerta(error.response?.data?.message || "No se pudo rechazar la reserva", "danger");
    }
  };

  // Formato de fecha amigable (ej: "lun 3 mar")
  const formatFecha = (fechaStr) => {
    if (!fechaStr) return "—";

    const [year, month, day] = fechaStr.split("-").map(Number);
    const fecha = new Date(year, month - 1, day);

    return fecha.toLocaleDateString("es-EC", {
      weekday: "short",
      day: "numeric",
      month: "short",
    });
  };

  const mostrarAlerta = (mensaje, tipo = "success") => {
  setAlerta({
    mostrar: true,
    mensaje,
    tipo
  });

  setTimeout(() => {
    setAlerta({
      mostrar: false,
      mensaje: "",
      tipo: "success"
    });
  }, 3000);
};
  


  return (
    <div className="container-fluid bg-light min-vh-100 py-4 px-3 px-md-4 px-lg-5">

      {alerta.mostrar && (
  <div
    className={`alert alert-${alerta.tipo} alert-dismissible fade show shadow position-fixed`}
    style={{
      top: "20px",
      right: "20px",
      zIndex: 9999,
      minWidth: "320px"
    }}
  >
    <div className="d-flex align-items-center">
      <i
        className={`bi me-2 ${
          alerta.tipo === "success"
            ? "bi-check-circle-fill"
            : alerta.tipo === "danger"
            ? "bi-x-circle-fill"
            : "bi-info-circle-fill"
        }`}
      ></i>

      <span>{alerta.mensaje}</span>
    </div>

    <button
      className="btn-close"
      onClick={() => setAlerta({ ...alerta, mostrar: false })}
    ></button>
  </div>
)}
      {/* Header */}
      <div className="card shadow-sm border-0 mb-4 border-start border-success border-4 rounded-3">
        <div className="card-body d-flex flex-wrap justify-content-between align-items-center gap-3 py-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-outline-success border-0 rounded-circle p-2"
              onClick={() => navigate("/DashboardSecretaria")}
              title="Volver"
            >
              <i className="bi bi-arrow-left-short fs-4"></i>
            </button>

            <h4 className="fw-bold mb-0 text-dark">
              <i className="bi bi-calendar-check me-2 text-success"></i>
              Gestión de Reservas
            </h4>
          </div>
        </div>
      </div>

      {/* Filtro por estado */}
      {!loading && reservas.length > 0 && (
        <div className="mb-4">
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <label className="fw-medium text-muted me-2">Filtrar por estado:</label>

            <div className="btn-group btn-group-sm" role="group">
              <button
                type="button"
                className={`btn btn-outline-secondary ${filtroEstado === "TODAS" ? "active" : ""}`}
                onClick={() => setFiltroEstado("TODAS")}
              >
                Todas
              </button>
              <button
                type="button"
                className={`btn btn-outline-secondary ${filtroEstado === "PENDIENTE" ? "active" : ""}`}
                onClick={() => setFiltroEstado("PENDIENTE")}
              >
                Pendientes
              </button>
              <button
                type="button"
                className={`btn btn-outline-secondary ${filtroEstado === "APROBADA" ? "active" : ""}`}
                onClick={() => setFiltroEstado("APROBADA")}
              >
                Aprobadas
              </button>
              <button
                type="button"
                className={`btn btn-outline-secondary ${filtroEstado === "RECHAZADA" ? "active" : ""}`}
                onClick={() => setFiltroEstado("RECHAZADA")}
              >
                Rechazadas
              </button>
            </div>

            <small className="text-muted ms-3">
              {reservasFiltradas.length} reserva
              {reservasFiltradas.length !== 1 ? "s" : ""}
            </small>
          </div>
        </div>
      )}

      {/* Contenido principal */}
      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      ) : reservasFiltradas.length === 0 ? (
        <div className="card border-0 shadow-sm text-center p-5">
          <i className="bi bi-calendar-x fs-1 text-success opacity-50 mb-3"></i>
          <h5 className="text-muted">
            {filtroEstado === "TODAS"
              ? "No hay reservas registradas"
              : `No hay reservas ${filtroEstado.toLowerCase()}`}
          </h5>
        </div>
      ) : (
        <div className="row g-3">
          {reservasFiltradas.map((reserva) => (
            <div className="col-xl-3 col-lg-4 col-md-6" key={reserva.id}>
              <div className="card shadow-sm border-0 rounded-3 overflow-hidden h-100">
                {/* Imagen espacio */}
                {reserva.espacio?.imagen ? (
                  <img
                    src={reserva.espacio.imagen}
                    alt={reserva.espacio.nombre}
                    className="card-img-top"
                    style={{
                      height: "120px",
                      objectFit: "cover",
                      background: "#f8f9fa",
                    }}
                    onError={(e) => {
                      e.target.src = "https://via.placeholder.com/400x120?text=Espacio";
                    }}
                  />
                ) : (
                  <div
                    className="bg-light d-flex align-items-center justify-content-center"
                    style={{ height: "120px" }}
                  >
                    <i className="bi bi-building fs-2 text-muted"></i>
                  </div>
                )}

                <div className="card-body p-3 d-flex flex-column">
                  <h6
                    className="card-title fw-bold mb-2 text-truncate"
                    style={{ fontSize: "1.05rem" }}
                  >
                    {reserva.espacio?.nombre || "Sin espacio"}
                  </h6>

                  <div className="text-muted" style={{ fontSize: "0.875rem" }}>
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <i className="bi bi-person-fill fs-6"></i>
                      <span className="text-truncate">
                        {reserva.usuario?.nombres ||
                          reserva.usuario?.email ||
                          "—"}
                      </span>
                    </div>

                    <div className="d-flex align-items-center gap-2 mb-1">
                      <i className="bi bi-calendar-event fs-6"></i>
                      {formatFecha(reserva.fecha)}
                    </div>

                    {reserva.hora_inicio && reserva.hora_fin && (
                      <div className="d-flex align-items-center gap-2">
                        <i className="bi bi-clock fs-6"></i>
                        {reserva.hora_inicio.slice(0, 5)} – {reserva.hora_fin.slice(0, 5)}
                      </div>
                    )}

                    {reserva.observacion && (
  <div className="mt-2">
    <small className="fw-bold text-dark">
      <i className="bi bi-chat-left-text me-1"></i>
      Observación:
    </small>
    <div
      className="small text-muted mt-1"
      style={{
        background: "#f8f9fa",
        borderRadius: "8px",
        padding: "8px",
      }}
    >
      {reserva.observacion}
    </div>
  </div>
)}
                  </div>

                  <div className="mt-auto pt-2">
                    <span
                      className={`badge px-2 py-1 fs-6 ${
                        reserva.estado === "PENDIENTE"
                          ? "bg-warning text-dark"
                          : reserva.estado === "APROBADA"
                          ? "bg-success"
                          : reserva.estado === "RECHAZADA"
                          ? "bg-danger"
                          : "bg-secondary"
                      }`}
                    >
                      {reserva.estado}
                    </span>
                  </div>
                </div>

                {reserva.estado === "PENDIENTE" && (
                  <div className="card-footer bg-white border-0 p-2 d-flex gap-2">
                    <button
                      className="btn btn-success btn-sm flex-fill d-flex align-items-center justify-content-center gap-1"
                      onClick={() => abrirModalAprobar(reserva.id)}
                    >
                      <i className="bi bi-check-lg"></i>
                      Aprobar
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm flex-fill d-flex align-items-center justify-content-center gap-1"
                      onClick={() => abrirModalRechazo(reserva.id)}
                    >
                      <i className="bi bi-x-lg"></i>
                      Rechazar
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal APROBAR */}
      {mostrarModalAprobar && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-3 shadow border-0">
              <div className="modal-header bg-success text-white">
                <h5 className="modal-title fw-bold">Aprobar Reserva</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setMostrarModalAprobar(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p className="mb-0">
                  ¿Estás seguro de que deseas <strong>aprobar</strong> esta reserva?
                </p>
              </div>
              <div className="modal-footer border-0">
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setMostrarModalAprobar(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-success px-4"
                  onClick={confirmarAprobar}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal RECHAZAR */}
      {mostrarModalRechazo && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content rounded-3 shadow border-0">
              <div className="modal-header bg-danger text-white">
                <h5 className="modal-title fw-bold">Rechazar Reserva</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setMostrarModalRechazo(false)}
                ></button>
              </div>

              <div className="modal-body">
                <p className="mb-3 text-muted">
                  Por favor indica el motivo del rechazo:
                </p>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Escribe aquí el motivo..."
                  value={motivoRechazo}
                  onChange={(e) => setMotivoRechazo(e.target.value)}
                  autoFocus
                ></textarea>
              </div>

              <div className="modal-footer border-0">
                <button
                  className="btn btn-outline-secondary px-4"
                  onClick={() => setMostrarModalRechazo(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-danger px-4"
                  onClick={confirmarRechazo}
                  disabled={!motivoRechazo.trim()}
                >
                  Rechazar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GestionReservas;